import { render } from "./SalesDestinationList.vue?vue&type=template&id=2718ee9b&ts=true"
import script from "./SalesDestinationList.vue?vue&type=script&lang=ts"
export * from "./SalesDestinationList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__